// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"6227":"9ee58144bbea68fb","9194":"042c5e7d9c148571"}[chunkId] + ".js";
};